// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2XPfs","list":"styles_list__2aoyM"};